// export const apiUrl:string = 'http://192.168.200.210:3019'
export const apiUrl:string = 'http://api.aline.com.cn'


import {ref} from 'vue'
import { useStore } from 'vuex';
// 获取 store 实例
const store = useStore();
// 图片的 ref 数组
export const imageRefs:any = ref([]);
// 设置图片的 ref
export const setImageRef = (el:any, index:number) => {
  if (el) {
    imageRefs.value[index] = el;
  }
};
// 图片加载完成后的回调
export const onImageLoad = (index:number) => {
  const img = imageRefs.value[index];
  if (img) {
    store.commit('setbannerHeight',img.height - 110);
  }
};